//@ts-ignore
import Switch from 'react-input-switch';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';

const SwitcherWrapper = styled.div<{ switchValue: any}>`
      .showcase-switcher {
    margin-bottom: 0px;
    height: 24px;
    width: 48px;

    span:not(:last-child) {
      background-color: ${({ switchValue }) => switchValue === 1 ? '#27AE60' : '#70706F'};
      border-radius: 19px;
    }

    span:last-child {
      top: 50%;
      transform: translateY(-50%);
      width: 16px;
      height: 16px;
      border-radius: 50%;
      left: 10%;
      ${({ switchValue }) => switchValue === 0 ? css`
      background-color: #fff;
      ` : css`
        left: 57%;
      `};
    }
}
`;

export const Switcher = forwardRef<any, {
  value: number;
  label: string;
  onChange: (value: number | boolean) => void;
}>(({ value, label, onChange }, ref) => {
  return (
    <SwitcherWrapper ref={ref} switchValue={value}>
    <Switch className={'showcase-switcher'} value={value} onChange={onChange} />
    </SwitcherWrapper>
  );
});
//@ts-ignore
import Switch from 'react-input-switch';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';

const SwitcherWrapper = styled.div<{ switchValue: any}>`
      .showcase-switcher {
    margin-bottom: 0px;
    height: 24px;
    width: 48px;

    span:not(:last-child) {
      background-color: ${({ switchValue }) => switchValue === 1 ? '#27AE60' : '#70706F'};
      border-radius: 19px;
    }

    span:last-child {
      top: 50%;
      transform: translateY(-50%);
      width: 16px;
      height: 16px;
      border-radius: 50%;
      left: 10%;
      ${({ switchValue }) => switchValue === 0 ? css`
      background-color: #fff;
      ` : css`
        left: 57%;
      `};
    }
}
`;

export const Switcher = forwardRef<any, {
  value: number;
  label: string;
  onChange: (value: number | boolean) => void;
}>(({ value, label, onChange }, ref) => {
  return (
    <SwitcherWrapper ref={ref} switchValue={value}>
    <Switch className={'showcase-switcher'} value={value} onChange={onChange} />
    </SwitcherWrapper>
  );
});
